/**
 * "Which WhatsApp?" picker for adding contacts (single and CSV). Renders nothing when there is only one way to add a
 * contact (the usual case), so existing flows look exactly as before. See useContactChannel for the rules.
 */
import React from "react";
import { isQrNumberUsableState } from "../../../utils/qrNumberState";
import { Box, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Typography, InputLabel } from "@mui/material";

// Larger than the app default so the choice is easy to read in the add / import dialogs.
const FONT = { "& .MuiFormControlLabel-label": { fontSize: 16 } };

const ContactChannelPicker = ({ channelState }) => {
  const { showChoice, qrOnly, hasQr, numbers, channel, setChannel, connectionId, setConnectionId, anyConnected, usingQr } = channelState;
  if (!hasQr) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {showChoice && (
        <FormControl>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, fontSize: 16 }}>Add this contact on</Typography>
          <RadioGroup value={channel} onChange={(e) => setChannel(e.target.value)}>
            <FormControlLabel value="meta" sx={FONT} control={<Radio />} label="WhatsApp Business API (official)" />
            <FormControlLabel
              value="qr"
              sx={FONT}
              disabled={!anyConnected}
              control={<Radio />}
              label={anyConnected ? "WhatsApp number linked by QR" : "WhatsApp number linked by QR (no number connected)"}
            />
          </RadioGroup>
        </FormControl>
      )}
      {usingQr && (
        <FormControl fullWidth>
          <InputLabel id="contact-qr-number-label" sx={{ fontSize: 16 }}>{qrOnly ? "WhatsApp number" : "QR number"}</InputLabel>
          <Select
            labelId="contact-qr-number-label"
            label={qrOnly ? "WhatsApp number" : "QR number"}
            value={connectionId}
            sx={{ fontSize: 16 }}
            onChange={(e) => setConnectionId(e.target.value)}
          >
            {numbers.map((n) => (
              <MenuItem key={n.connectionId} sx={{ fontSize: 16 }} value={n.connectionId} disabled={!isQrNumberUsableState(n.state)}>
                {n.label || n.phoneNumber || `Number ${n.slot + 1}`}
                {!isQrNumberUsableState(n.state) ? " (logged out)" : ""}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default ContactChannelPicker;
